/**
 * Domain 카드 그리드 — 각 카드는 name/displayName/description + color 스와치 + usage 배지.
 */
import type { DomainDef } from "../../api/admin-client.ts"
import { DOMAIN_COLORS } from "../graph/graph-colors.ts"

interface DomainCardGridProps {
	readonly domains: ReadonlyArray<DomainDef>
	readonly usage?: Record<string, number>
	readonly selectedName?: string
	readonly onSelect: (name: string) => void
	readonly onAdd: () => void
	readonly onDelete: (name: string) => void
}

function resolveDomainColor(domain: DomainDef): string {
	return domain.color ?? DOMAIN_COLORS[domain.name] ?? DOMAIN_COLORS.default ?? "#8b949e"
}

export function DomainCardGrid(props: DomainCardGridProps) {
	return (
		<section className="ontology-section">
			<h3 className="ontology-section-title">
				Domains <span className="muted">({props.domains.length})</span>
			</h3>
			<div className="ontology-card-grid">
				{props.domains.map((domain) => {
					const used = props.usage?.[domain.name] ?? 0
					const isSelected = props.selectedName === domain.name
					const color = resolveDomainColor(domain)
					return (
						<button
							type="button"
							key={domain.name}
							className={`ontology-card${isSelected ? " is-selected" : ""}`}
							onClick={() => props.onSelect(domain.name)}
						>
							<div className="ontology-card-head">
								<span className="ontology-card-swatch" style={{ background: color }} aria-hidden />
								<div className="ontology-card-title">
									<strong>{domain.displayName || domain.name}</strong>
									<code className="inline">{domain.name}</code>
								</div>
								<button
									type="button"
									className="ontology-card-remove"
									aria-label={`${domain.name} 삭제`}
									onClick={(e) => {
										e.stopPropagation()
										props.onDelete(domain.name)
									}}
								>
									×
								</button>
							</div>
							{domain.description && <p className="ontology-card-desc">{domain.description}</p>}
							<div className="ontology-card-foot">
								<span className={`badge${used > 0 ? " badge-active" : " badge-disabled"}`}>
									{used}회 사용
								</span>
							</div>
						</button>
					)
				})}

				<button type="button" className="ontology-card ontology-card-add" onClick={props.onAdd}>
					<span className="ontology-card-add-plus" aria-hidden>
						+
					</span>
					<span>Domain 추가</span>
				</button>
			</div>
		</section>
	)
}
